<template>
	<div class="container_head ">
		<van-form >
			<van-cell-group style="margin-top: 5px;">
			
				<!-- <van-field v-model="data.preStoreAmount" label="预存金额" placeholder="暂无" input-align="right"   readonly   /> -->
				<van-field v-model="data.balanceAmount" label="账户余额" placeholder="暂无" input-align="right" readonly  />
				<van-field v-model="data.villageName" label="小区名称" placeholder="暂无" input-align="right" readonly  />
				<van-field v-model="data.houseInfo" label="房屋信息" placeholder="暂无" input-align="right"   readonly   />
				<!-- <van-field v-model="data.requireAmount" label="应缴金额" input-align="right" readonly  /> -->
				<van-field v-model="data.warningAmount" label="预警金额" placeholder="暂无" input-align="right" readonly  />
				<!-- <van-field v-model="data.breachAmount" label="缺口金额" placeholder="暂无" input-align="right"   readonly v-show="showbreach"  /> -->
				<van-field v-model="data.lastIncomeAmount" label="最近一笔存入金额" placeholder="暂无" input-align="right" readonly  />
				<!-- <van-field v-model="data.lastPayAmount" label="最近一笔使用金额" placeholder="暂无" input-align="right" readonly  /> -->
				<!-- <van-field v-model="data.status" label="账户状态" input-align="right" readonly  /> -->
			</van-cell-group>
		</van-form>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Image as VanImage,Cascader
	} from 'vant';
	Vue.use(VanImage).use(Cascader);
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		Field,Form 
	} from 'vant';
	Vue.use(Field);
	Vue.use(Form);
	export default {
		data() {
			return {
				showbreach:false,
				data:{
					preStoreAmount:'',
					balanceAmount:'',
					villageName:'',
					houseInfo:'',
					requireAmount:'',
					warningAmount:'',
					breachAmount:'',
					lastIncomeAmount:'',
					lastPayAmount:'',
					status:''
				}
				
			};
		},
		computed: {
			...mapState(['userInfo','identity','houseId']),
		},
		mounted() {
			this.$axios.get('/api/v1/maintenance/house/'+this.houseId).then(res=>{
				
				for(let key in this.data){
					this.$set(this.data,key,res[key])
				}
				if(this.data.breachAmount.indexOf('-') != -1){
					this.showbreach = false
				}else{
					this.showbreach = true
				}
			})
			
		},
		methods: {
			...mapMutations(['changeIdentity','changeUserinfo']),
			changeview(path) {
				this.$router.push(path);
			},
		}
	};
</script>

<style lang="less" scoped>
	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.qrxg{
		padding: 40px;
	}
</style>
